import { Injectable } from '@angular/core';
import { UserAddressConnector, Address } from '@spartacus/core';
import { CustomUserAddressAdapter } from '../../../occ/adapters/adapter/custom-user-address.adapter';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomUserAddressConnector extends UserAddressConnector {
  constructor(protected adapter: CustomUserAddressAdapter) {
    super(adapter);
  }

  getAllByZone(userId: string, zone?: string): Observable<Address[]> {
    return this.adapter.loadAllByZone(userId, zone);
  }
}
